/** @jsxImportSource theme-ui */
import React from 'react';

import { Typography } from 'components/_common/Typography';

export const SparkTooltipLoading: React.FC = () => (
  <Typography variant="caption" color="stone10">
    Loading...
  </Typography>
);
